import clsx from 'clsx'
import React from 'react'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import {
  getNonGeneralWidgetUrl,
  NON_GENERAL_WIDGET,
  trackWidgetClick,
} from './utils'
import { Anchor } from 'components/Anchor'

import type { IAksiNyata } from './typings'

const BaseWidget = React.forwardRef<
  HTMLDivElement,
  IAksiNyata & { className?: string }
>(
  (
    {
      title,
      author,
      thumbnailUrl,
      className,
      topicId,
      topicName,
      id,
      trackerWidgetData,
    },
    ref
  ) => {
    const url = getNonGeneralWidgetUrl({
      type: NON_GENERAL_WIDGET.AksiNyata,
      id,
      topicId,
      topicName,
    })
    return (
      <Anchor href={url} className="mb-2 last:mb-0 block">
        <div
          className={clsx(
            'widget-component',

            'rounded border border-subdued p-3 bg-white',
            'flex gap-4 justify-between',
            'cursor-pointer',
            className
          )}
          ref={ref}
          onClick={() =>
            trackWidgetClick({
              ...trackerWidgetData,
              widgetValue: {
                ...trackerWidgetData.widgetValue,
                url,
              },
            })
          }
        >
          <div>
            <Text className="mb-2 line-clamp-2" variant="action">
              {title}
            </Text>
            <Text variant="helper" className="mb-0 line-clamp-1">
              {author}
            </Text>
          </div>
          <div className="relative flex-grow-0 flex-shrink-0 w-[90px] h-16 rounded overflow-hidden">
            {!!thumbnailUrl && (
              <img
                className="object-cover object-center w-[90px] h-16"
                alt="topic thumbnail"
                src={thumbnailUrl}
              />
            )}
            {!thumbnailUrl && (
              <div className="grid place-items-center w-[90px] h-16 bg-gray-30">
                <Icon>article</Icon>
              </div>
            )}
          </div>
        </div>
      </Anchor>
    )
  }
)
BaseWidget.displayName = 'AksiNyata'

export default BaseWidget
